import request from 'server'
/**
 * 客服管理
 * @param data
 * @returns
 */
export const getEmplyeeList = (data: object) => {
  return request({
    url: `/workflow/borrow/historys`,
    method: 'post',
    data,
  })
}
// 获取区域列表
export const getPosterAreaList = () => {
  return request({
    url: `/customer/order/getRegionList`,
    method: 'post',
  })
}

//预支审批
// 客服客户列表
export const findDepartmentAll = () => {
  return request({
    url: `/customer/department/findDepartmentAll`,
    method: 'get',
  })
}
// 用工单位/批量续签企业列表
export const getDepts = () => {
  return request({
    url: `/customer/customerService/findDepartmentsByUserToken`,
    method: 'get',
  })
}

// 获取当前部门的续签订单
export const getExtensionOrdersByDeptId = (data: any) => {
  return request({
    url: `/customer/order/getExtensionOrdersByDeptId`,
    method: 'post',
    data,
  })
}
// 批量新增续签人员
export const addExtensionPersons = (data: any) => {
  return request({
    url: `/recruitment/extensionPersons/addExtensionPersons`,
    method: 'post',
    data,
  })
}
// 用工单位-全部
export const getDeptsAll = () => {
  return request({
    url: `/customer/department/findDepartmentAll`,
    method: 'get',
  })
}

// 驻厂获取个性设置用工单位
export const getCustomDepts = () => {
  return request({
    url: `/system/sysUserDiyConfig/getConfig`,
    method: 'get',
  })
}
// 驻厂设置用工单位
export const setCustomDepts = (data: any) => {
  return request({
    url: `/system/sysUserDiyConfig/setConfig`,
    method: 'post',
    data,
  })
}
/**
 * 我的待办
 * @param data
 * @returns
 */
export const getTodos = (data: object) => {
  return request({
    url: `/workflow/borrow/todos`,
    method: 'post',
    data,
  })
}

// 审批
export const showApproval = (data: []) => {
  return request({
    url: `/workflow/task/form/show`,
    method: 'post',
    data,
  })
}
// 保存审批
export const saveApproval = (data: Object) => {
  return request({
    url: `/workflow/task/form/save`,
    method: 'post',
    data,
  })
}

export const importApproval = (data: any) => {
  return request({
    url: `/workflow/task/import/audit`,
    method: 'post',
    data,
  })
}
/**
 * 我的已办
 * @param data
 * @returns
 */
export const getHistorys = (data: object) => {
  return request({
    url: `/workflow/borrow/historys`,
    method: 'post',
    data,
  })
}

// 预支详情
export const getDetail = (id: string) => {
  return request({
    url: `/workflow/borrow/detail/${id}`,
    method: 'get',
  })
}
/**
 * 员工管理
 */

// 客服所在工厂列表
export const getFactories = (shortName: string) => {
  return request({
    url: `/recruitment/factoryMember/factories?shortName=${shortName}`,
    method: 'get',
  })
}

// /
export const getFactories2 = (shortName: string) => {
  return request({
    url: `/recruitment/factoryMember/factories2?shortName=${shortName}`,
    method: 'get',
  })
}
// 批量续签员工列表
export const getMemberList = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/memberList`,
    method: 'post',
    data,
  })
}
// 查询指定续签人员列表
export const chooseExtensionPerson = (data: any) => {
  return request({
    url: `/recruitment/extensionPersons/chooseExtensionPerson`,
    method: 'post',
    data,
  })
}

// 离职明细列表
export const resignationDetails = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/resignationDetails`,
    method: 'post',
    data,
  })
}
// H项目组看不到 企业订单
export const orderMemberRecruitments = (data: any) => {
  return request({
    url: '/customer/order/member/recruitments/select',
    method: 'post',
    data,
  })
}
export const getWeeksDate = (data: any = {}) => {
  return request({
    url: `/recruitment/factoryMember/getWeeksDate`,
    method: 'post',
    data,
  })
}

export const leavefollowDetail = (data: any) => {
  return request({
    url: `/kefu/leavefollow/detail`,
    method: 'post',
    data,
  })
}

// 批量离职转在职
export const quitToInductionBatch = (data: any) => {
  return request({
    url: `/recruitment/newEmployee/quitToInductionBatch`,
    method: 'post',
    data,
  })
}

export const resignationDetailsExport = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/resignationDetailsExport`,
    method: 'post',
    data,
  })
}
// 查询工厂员工详情
export const getFactoriesDetail = (factoryRegisterId: string) => {
  return request({
    url: `/recruitment/factoryMember/detail/${factoryRegisterId}`,
    method: 'get',
  })
}

// 获取反诈签署
export const getAntifraudSigned = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/getAntifraudSigned`,
    method: 'post',
    data,
  })
}

// 修改员工基本信息
export const updateMemberInfo = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/updateMemberInfoWeb`,
    method: 'post',
    data,
  })
}

//
export const updateMemberInfoWebApply = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/updateMemberInfoWebApply`,
    method: 'post',
    data,
  })
}

// 验证银行卡
export const checkBankCard = (bankcard: string) => {
  return request({
    url: `/external-api/eApi/accountAuth/getBankcardInfo/${bankcard}`,
    method: 'get',
  })
}

// 修改员工基本信息
export const updateBaseInfo = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/updateBaseInfo`,
    method: 'post',
    data,
  })
}
export const delUser = (factoryRegisterId: any) => {
  return request({
    url: `/recruitment/factoryMember/deleteMemberInfoWeb/${factoryRegisterId}`,
    method: 'post',
  })
}
// 修改银行卡
export const updateBankCard = (data: any) => {
  return request({
    url: `/recruitment/factoryMember/updateBankCard`,
    method: 'post',
    data,
  })
}
// 获取转在职员工列表
export const getEmployeeList = (data: any) => {
  return request({
    url: `/recruitment/newEmployee/inOfficeEmployeeList`,
    method: 'post',
    data,
  })
}

// 批量转在职
export const updateEmployeeStauts = (data: any) => {
  return request({
    url: `/recruitment/newEmployee/updateBatchInOfficeEmployee`,
    method: 'post',
    data,
  })
}
// 批量转离职
export const updateBatchQuitEmployee = (data: any) => {
  return request({
    url: `/recruitment/newEmployee/updateBatchQuitEmployee`,
    method: 'post',
    data,
  })
}
// 批量补资料提醒
export const noticeBath = (data: any) => {
  return request({
    url: `/recruitment/receptionist/noticeBath`,
    method: 'post',
    data,
  })
}
// 上传员工离职表
export const uploadEmployeeExcel = (data: any) => {
  return request({
    url: `/recruitment/newEmployee/importQuitEmployee`,
    method: 'post',
    data,
  })
}
//员工管理 - 操作日志
export const getOperationLogList = (data: any) => {
  return request({
    url: `/recruitment/operationLogController/getOperationLogList`,
    method: 'post',
    data,
  })
}
/**
 * 更新员工信息
 */
export const apiImportUpdateEmployee = (data: any) => {
  return request({
    url: `/recruitment/newEmployee/importUpdateEmployee`,
    method: 'POST',
    data: data,
  })
}
// 查询工作经历
export const workExperienceList = (memberId: string) => {
  return request({
    url: `/recruitment/recSignUp/getWorkExperience/${memberId}`,
    method: 'get',
  })
}
// 查询工作经历基本信息
export const workExperienceInfo = (data: any) => {
  return request({
    url: `/recruitment/recSignUp/getWorkExperienceInfo`,
    method: 'post',
    data,
  })
}
// 员工详情借支记录攻击
export const borrowList = (departmentId: string, memberId: string) => {
  return request({
    url: `/finance/borrow/employee/sum/${departmentId}/${memberId}`,
    method: 'get',
  })
}

// 薪资查询
export const salaryList = (data: any) => {
  return request({
    url: `/finance/salary/detail/forWeb`,
    method: 'post',
    data,
  })
}

// 签约主体
export const companyList = () => {
  return request({
    url: `/customer/company/findAll`,
    method: 'get',
  })
}

// 企业部门树形
export const getCustomerDepartmentTree = () => {
  return request({
    url: `/customer/department/getCustomerDepartmentTree`,
    method: 'post',
    data: {},
  })
}
// 投诉列表
export const complaintList = (id: string) => {
  return request({
    url: `/system/complaint/web/getListByMemberId/${id}`,
    method: 'get',
    data: {},
  })
}
// 报到转离职
export const getDimissionList = (data: any) => {
  return request({
    url: `/recruitment/employee/reportToQuitPage`,
    method: 'post',
    data,
  })
}
// 招聘报备自离
export const selectSelfDepartureReportingPage = (data: any) => {
  return request({
    url: `/recruitment/selfDepartureReporting/selectSelfDepartureReportingPage`,
    method: 'post',
    data,
  })
}
// 离职日期异常列表
export const getOnJobAbnormalList = (data: any) => {
  return request({
    url: `/kefu/onJobAbnormal/list`,
    method: 'post',
    data,
  })
}
// 离职日期点击处理调用
export const getOnJobAbnormalCanEdit = (data: any) => {
  return request({
    url: `/kefu/onJobAbnormal/canEdit`,
    method: 'post',
    data,
  })
}
// 修改在离职日期
export const getOnJobAbnormalEditTime = (data: any) => {
  return request({
    url: `/kefu/onJobAbnormal/editTime`,
    method: 'post',
    data,
  })
}
// 表单手机列表
export const getFormList = (data: any) => {
  return request({
    url: `/system/formcollection/getFormCollection`,
    method: 'post',
    data,
  })
}
// 新增编辑表单
export const getAddOrEdit = (data: any) => {
  return request({
    url: `/system/formcollection/updateFormCollection`,
    method: 'post',
    data,
  })
}
// 查询收集表单字段
export const getFormFields = (id: number) => {
  return request({
    url: `/system/formcollection/getFormfield/${id}`,
    method: 'get',
    data: {},
  })
}

// 删除
export const operationDelForm = (id: number) => {
  return request({
    url: `/system/formcollection/deleteById/${id}`,
    method: 'post',
    data: {},
  })
}
// 表单收集word模板新增更新
export const formModuleUpdate = (data: {
  formId: number
  wordTemplateUrl: string
}) => {
  return request({
    url: `/system/formcollection/updateWordTemplate`,
    method: 'post',
    data,
  })
}
// 表单收集字段新增更新
export const formFieldUpdate = (data: {
  formId: number
  fieldJson: string
}) => {
  return request({
    url: `/system/formcollection/updateFormfield`,
    method: 'post',
    data,
  })
}
// 获取表单提交数据
export const getFormCollectionData = (data: { formId: number }) => {
  return request({
    url: `/system/formcollection/getFormCollectionDetails`,
    method: 'post',
    data,
  })
}
// 获取查看数据表头
export const getFormCollectionTableHeader = (id: number) => {
  return request({
    url: `/system/formcollection/getFormDetailsfieldHead/${id}`,
    method: 'get',
    data: {},
  })
}
// 导出word文档
export const exportWord = (data: string[]) => {
  return request({
    url: `/system/formcollection/exportWordTemplate`,
    method: 'post',
    data,
  })
}
// 批量导出图片
export const exportPicture = (data: string[]) => {
  return request({
    url: `/system/formcollection/exportPictures`,
    method: 'post',
    data,
  })
}
// 导出word文档下载列表
export const downloadWordFile = (data: any) => {
  return request({
    url: `/system/formcollection/getWordFileList`,
    method: 'post',
    data,
  })
}
// 输送数据简报
export const getTransportData = (data: any) => {
  return request({
    url: `/recruitment/recSignUp1/getTransportData`,
    method: 'post',
    data,
  })
}
// 在离职数据简报
export const getAfterLeavingData = (data: any) => {
  return request({
    url: `/recruitment/exitStatisticsBoard/exitStatisticsBoard`,
    method: 'post',
    data,
  })
}
// 在离职数据简报-明细
export const getAfterLeavingDetail = (
  url: string,
  data: {
    beginDate: string
    endDate: string
    employmentMode: string | null | undefined
    dateType: number
    viewType: number | string
  },
) => {
  return request({
    url: url,
    method: 'post',
    data,
  })
}

// 考勤记录列表
export const attendanceGetPage = (data: any) => {
  return request({
    url: `/member-service/clockAttendanceRecord/getPage`,
    method: 'post',
    data,
  })
}
// 考勤组
export const attendanceGroup = (data: any) => {
  return request({
    url: `/member-service/clockAttendance/getPage`,
    method: 'post',
    data,
  })
}

// 财务管理 - 资金流水
export const fundsFlowDetails = (data: any) => {
  return request({
    url: `/member/refeeDetailRewards/fundsFlowDetails`,
    method: 'post',
    data,
  })
}

export const selectAccounts = (data: any) => {
  return request({
    url: `/member/alipayAccountInfo/selectAccounts`,
    method: 'post',
    data,
  })
}
// 资金流水 - 金额统计
export const fundsFlowSum = (data: any) => {
  return request({
    url: `/member/refeeDetailRewards/fundsFlowSum`,
    method: 'post',
    data,
  })
}

// 周报管理
// 周报管理列表
export const deptWeekReportList = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/selectPageList`,
    method: 'post',
    data,
  })
}
// 周报管理-离职明细
export const selectQuitDetailPageList = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/selectQuitDetailPageList`,
    method: 'post',
    data,
  })
}
// 周报管理-查询周报流失分析列表
export const selectLoseReportList = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/selectLoseReportList`,
    method: 'post',
    data,
  })
}
// 周报管理列表
export const deptWeekReport2List = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/selectList`,
    method: 'post',
    data,
  })
}
// 客服下拉
export const selectComplaintUserList = () => {
  return request({
    url: `/customer/department/selectComplaintUserList`,
    method: 'post',
  })
}
// 所属区域下拉
export const selectAreaList = () => {
  return request({
    url: `/recruitment/serviceAreaConfigController/listArea`,
    method: 'get',
  })
}
// 近一年周数下拉
export const getWeeks = () => {
  return request({
    url: `/recruitment/deptWeekReportNew/getWeeks`,
    method: 'post',
  })
}
// 企业部门下拉列表
export const getDepartmentList = (data?: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/getDepartmentList`,
    method: 'post',
    data,
  })
}
// 查询当前是否可以提交周报
export const getCanWrite = () => {
  return request({
    url: `/recruitment/deptWeekReportNew/canWrite`,
    method: 'post',
  })
}
// 最近四周提报明细
export const getWeeksWriteList = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/getWeeksWriteList`,
    method: 'post',
    data,
  })
}
// 查询提报周报列表
export const selectWriteList = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/selectWriteList`,
    method: 'post',
    data,
  })
}
// 保存提报周报
export const saveWriteList = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/saveWriteList`,
    method: 'post',
    data,
  })
}
// 查询提报周报权限 1：提报周报 2：提报情况
export const selectWriteInfoPermit = () => {
  return request({
    url: `/recruitment/deptWeekReportNew/selectWriteInfoPermit`,
    method: 'post',
  })
}
// 查询提报情况
export const getWeeksWriteInfoByPage = (data: any) => {
  return request({
    url: `/recruitment/deptWeekReportNew/getWeeksWriteInfoByPage`,
    method: 'post',
    data,
  })
}

/**
 * 客服报表-工作汇报
 */

// 所有区域
export const getAreaInfoAll = () => {
  return request({
    url: `/kefu/abnormalEvent/getAreaInfoAll`,
    method: 'post',
  })
}

// 异常明细列表
export const abnormalEventDetails = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/abnormalEventDetails`,
    method: 'post',
    data,
  })
}
// 异常明细 - 事件类型
export const abnormalEventStatistics = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/abnormalEventStatistics`,
    method: 'post',
    data,
  })
}
// 根据事件id获取区域
export const abnormalEventAreaStatistics = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/abnormalEventAreaStatistics`,
    method: 'post',
    data,
  })
}
// 流失分析
export const lossAnalysis = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/lossAnalysis`,
    method: 'post',
    data,
  })
}
// /kefu/abnormalEvent/v2/lossAnalysis
export const v2LossAnalysis = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/v2/lossAnalysis`,
    method: 'post',
    data,
  })
}
//本周更新异常
export const abnormalUpdateInWeek = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/abnormalUpdateInWeek`,
    method: 'post',
    data,
  })
}

// 工伤明细 - 统计
export const detailedInjuryStatistics = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/detailedInjuryStatistics`,
    method: 'post',
    data,
  })
}
// 工伤明细 - 列表
export const detailedInjury = (data: any) => {
  return request({
    url: `/kefu/abnormalEvent/detailedInjury`,
    method: 'post',
    data,
  })
}
// 获取客户部门
export const findDepartmentsByUserNew = () => {
  return request({
    url: `/customer/customerService/findDepartmentsByUserNew`,
    method: 'post',
  })
}
// 社保方案列表
export const socialSecurityPlanList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/plan/list`,
    method: 'post',
    data,
  })
}
// 新增/编辑社保方案
export const socialSecurityPlanAdd = (data: any) => {
  return request({
    url: `/finance/socialSecurity/plan/saveOrUpdate`,
    method: 'post',
    data,
  })
}
// 删除
export const socialSecurityPlanDelete = (data: any) => {
  return request({
    url: `/finance/socialSecurity/plan/delete`,
    method: 'post',
    data,
  })
}
// 获取社保方案详情
export const socialSecurityPlanDetail = (data: any) => {
  return request({
    url: `/finance/socialSecurity/plan/detail`,
    method: 'post',
    data,
  })
}
// 社保确认列表
export const socialSecurityConfirmList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/confirm/list`,
    method: 'post',
    data,
  })
}
// 发起社保确认列表
export const socialSecurityConfirmAdd = (data: any) => {
  return request({
    url: `/finance/socialSecurity/confirm/initiateList`,
    method: 'post',
    data,
  })
}
// 发起社保确认提交
export const socialSecurityConfirmSubmit = (data: any) => {
  return request({
    url: `/finance/socialSecurity/confirm/initiate/save`,
    method: 'post',
    data,
  })
}
// 关联名单-企业在职
export const socialSecurityConfirmRelation = (data: any) => {
  return request({
    url: `/finance/socialSecurity/confirm/onJobList`,
    method: 'post',
    data,
  })
}
// 关联名单-社保名单
export const socialSecurityConfirmRelationSocial = (data: any) => {
  return request({
    url: `/finance/socialSecurity/confirm/memberList`,
    method: 'post',
    data,
  })
}
// 关联名单-提交
export const socialSecurityConfirmRelationSubmit = (data: any) => {
  return request({
    url: `/finance/socialSecurity/confirm/memberList/save`,
    method: 'post',
    data,
  })
}
// 导入社保名单
export const socialSecurityConfirmImport = (url: string, data: any) => {
  return request({
    url: url,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' },
  })
}

/**
 * 社保档案
 */

// 列表
export const socialSecurityDossierList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/dossier/list`,
    method: 'post',
    data,
  })
}

// 档案删除
export const dossierDeleteMember = (data: any) => {
  return request({
    url: `/finance/socialSecurity/dossier/deleteMember`,
    method: 'post',
    data,
  })
}

// 新增参保档案 - 已选择人员名单
export const socialSecurityDossierMemberList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/dossier/memberList`,
    method: 'post',
    data,
  })
}
// 企业在职人员
export const socialSecurityDossierOnJobList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/dossier/onJobList`,
    method: 'post',
    data,
  })
}

// 新增参保档案 - 选择人员 提交
export const socialSecurityDossierSave = (data: any) => {
  return request({
    url: `/finance/socialSecurity/dossier/memberList/save`,
    method: 'post',
    data,
  })
}

// 参保台账 - 列表
export const ledgerList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/list`,
    method: 'post',
    data,
  })
}

export const socialSecurityLedgerDelete = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/delete`,
    method: 'post',
    data,
  })
}

// 参保台账 - 人员明细
export const ledgerDetailMemberList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/detail/memberList`,
    method: 'post',
    data,
  })
}

// 导出数据失败数据
export const socialSecurityLedgerDownload = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/download`,
    method: 'post',
    data,
  })
}

// 批量转正式工-员工库添加
export const socialSecurityLedgerAdd = (data: any) => {
  return request({
    url: `/recruitment/factoryMemberToRegular/getQuitList`,
    method: 'post',
    data,
  })
}
// 批量转正式工-保存
export const saveFactoryRegister = (data: any) => {
  return request({
    url: `/recruitment/factoryMemberToRegular/saveFactoryRegister`,
    method: 'post',
    data,
  })
}
// 批量转正式工-判断选择是否在职
export const getQuitListIsBeOnTheJob = (data: any) => {
  return request({
    url: `/recruitment/factoryMemberToRegular/getOnJobList`,
    method: 'post',
    data,
  })
}
// 工时管理-下载模版
export const downloadWorkHourTemplate = () => {
  return request({
    url: `/kefu/hours/templateDownload`,
    method: 'get',
    data: {},
  })
}
// 工时管理-导入工时
export const importWorkHour = (data: any) => {
  return request({
    url: `/kefu/hours/v2/uploadBatch`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' },
  })
}
// 工时管理-对应上传完成的操作
export const importWorkHourOperation = (data: any) => {
  return request({
    url: `/kefu/hours/uploadBatchComplete`,
    method: 'post',
    data,
  })
}
// 工时管理-工时列表
export const workHourList = (data: any) => {
  return request({
    url: `/kefu/hours/detailList`,
    method: 'post',
    data,
  })
}
export const workHourListNew = (data: any) => {
  return request({
    url: `/kefu/hours/v2/detailList`,
    method: 'post',
    data,
  })
}

// 工时上传情况列表
export const workHourUploadList = (data: any) => {
  return request({
    url: `/kefu/hours/uploadStatusList`,
    method: 'post',
    data,
  })
}
// 编辑说明
export const uploadStatusRemark = (data: any) => {
  return request({
    url: `/kefu/hours/uploadStatusRemark`,
    method: 'post',
    data,
  })
}

// 招聘服务工时列表
export const recruitmentWorkHourList = (data: any) => {
  return request({
    url: `/kefu/hours/recruitmentServiceList`,
    method: 'post',
    data,
  })
}

// 客服服务工时列表
export const customerServiceWorkHourList = (data: any) => {
  return request({
    url: `/kefu/hours/kefuServiceList`,
    method: 'post',
    data,
  })
}

// 客服工时明细列表
export const customerServiceWorkHourDetailList = (data: any) => {
  return request({
    url: `/kefu/hours/kefuServiceDetailList`,
    method: 'post',
    data,
  })
}
// 招聘服务工时明细列表
export const recruitmentWorkHourDetailList = (data: any) => {
  return request({
    url: `/kefu/hours/recruitmentServiceDetailList`,
    method: 'post',
    data,
  })
}
// 企业工时明细列表
export const kefuServiceCustomerDetailList = (data: any) => {
  return request({
    url: `/kefu/hours/kefuServiceCustomerDetailList`,
    method: 'post',
    data,
  })
}
// 企业工时汇总
export const customerUploadStatusList = (data: any) => {
  return request({
    url: `/kefu/hours/customerUploadStatusList`,
    method: 'post',
    data,
  })
}
/**
 * 预支审批-新
 */

// 我的待办
export const getBorrowTodos = (data: any) => {
  return request({
    url: `/finance/borrow/todos`,
    method: 'post',
    data,
  })
}
// 失败退回-退回人员
export const returnUsers = (data: any) => {
  return request({
    url: `/finance/borrow/todos/returnUsers`,
    method: 'post',
    data,
  })
}
export const getSignedList = (data: any) => {
  return request({
    url: `/finance/borrow/sign/getSignedList`,
    method: 'post',
    data,
  })
}
export const signDownload = (data: any) => {
  return request({
    url: `/finance/borrow/sign/download`,
    method: 'post',
    data,
  })
}

// 审批
export const borrowExamine = (data: any) => {
  return request({
    url: `/finance/borrow/examine`,
    method: 'post',
    data,
  })
}

// 更新签约主体
export const updateCompany = (data: any) => {
  return request({
    url: `/finance/borrow/updateCompany`,
    method: 'post',
    data,
  })
}

// 审批详情
export const borrowDetail = (recordId: string) => {
  return request({
    url: `/finance/borrow/detail/${recordId}`,
    method: 'get',
  })
}

// 导入
export const importApprovalNew = (data: any) => {
  return request({
    url: `/finance/borrow/importExamine`,
    method: 'post',
    data,
  })
}

// 已处理
export const getBorrowHistorys = (data: any) => {
  return request({
    url: `/finance/borrow/historys`,
    method: 'post',
    data,
  })
}

// 获取打印数据
export const getPayOrderPrint = (data: any) => {
  return request({
    url: `/finance/borrow/getPayOrderPrint`,
    method: 'post',
    data,
  })
}

// 开单明细/付款单 获取打印数据
export const getPayOrderPrintById = (data: any) => {
  return request({
    url: `/finance/borrow/getPayOrderPrintById`,
    method: 'post',
    data,
  })
}

// 提交付款单打印
export const submitPayOrderPrint = (data: any) => {
  return request({
    url: `/finance/borrow/submitPayOrderPrint`,
    method: 'post',
    data,
  })
}

// 付款单
export const getPayOrderList = (data: any) => {
  return request({
    url: `/finance/borrow/payOrderList `,
    method: 'post',
    data,
  })
}

// 付款单
export const payOrderList = (data: any) => {
  return request({
    url: `/finance/borrow/payOrderList`,
    method: 'post',
    data,
  })
}

// 取消付款单 / 退回
export const cancelPayOrderPrint = (data: any) => {
  return request({
    url: `/finance/borrow/cancelPayOrderPrintById`,
    method: 'post',
    data,
  })
}

// 银行出账单模板
export const getPayOrderBillList = (data: any) => {
  return request({
    url: `/finance/borrow/getPayOrderBillList`,
    method: 'post',
    data,
  })
}
// 失败退回银行出账单
export const getRecordBillList = (data: any) => {
  return request({
    url: `/finance/borrow/getRecordBillList`,
    method: 'post',
    data,
  })
}

// 财务放款 - 预支明细 - 导入异常退回
export const importPayFail = (data: any) => {
  return request({
    url: `/finance/borrow/importPayFail`,
    method: 'post',
    data,
  })
}

// 获取企业部门
export const customerServiceHoursDept = () => {
  return request({
    url: `/customer/customerService/hours/departments`,
    method: 'get',
    data: {},
  })
}

export const customerServiceHoursDeptTree = () => {
  return request({
    url: `/customer/customerService/hours/departments/tree`,
    method: 'get',
    data: {},
  })
}

export const findDepartmentsByUserToken = () => {
  return request({
    url: `/finance/borrowSetting/findDepartmentsByUserToken`,
    method: 'get',
  })
}

/**
 * 工时结算
 */

/**
 * 企业映射
 */
// 列表
export const getPageMapping = (data: any) => {
  return request({
    url: `/customer/customerMapping/getPage`,
    method: 'post',
    data,
  })
}

export const deleteMapping = (data: any) => {
  return request({
    url: `/customer/customerMapping/delete`,
    method: 'post',
    data,
  })
}

export const detailMapping = (data: any) => {
  return request({
    url: `/customer/customerMapping/detail`,
    method: 'post',
    data,
  })
}

export const getDeptList = (data: any = {}) => {
  return request({
    url: `/customer/customerMapping/getDepartmentTree`,
    method: 'post',
    data,
  })
}

export const saveMapping = (data: any) => {
  return request({
    url: `/customer/customerMapping/save`,
    method: 'post',
    data,
  })
}

// 客户关系
export const getRelationshipList = (data: any) => {
  return request({
    url: `/customer/department/relationship/getRelationshipList`,
    method: 'post',
    data,
  })
}

// 金蝶客户列表
export const getFinanceCustomerList = (data: any = {}) => {
  return request({
    url: `/customer/department/relationship/getFinanceCustomerList`,
    method: 'post',
    data,
  })
}

//
export const relationshipOperationLogList = (data: any) => {
  return request({
    url: `/customer/department/relationship/getOperationLogList`,
    method: 'post',
    data,
  })
}

export const saveFinanceCustomer = (data: any) => {
  return request({
    url: `/customer/department/relationship/saveFinanceCustomer`,
    method: 'post',
    data,
  })
}
/**
 * 体系管理
 *
 */

// 列表
export const customerSchemeList = (data: any) => {
  return request({
    url: `/customer/customerScheme/getList`,
    method: 'post',
    data,
  })
}

// 详情
export const customerSchemeDetail = (data: any) => {
  return request({
    url: `/customer/customerScheme/detail`,
    method: 'post',
    data,
  })
}

//  保存
export const customerSchemeSave = (data: any) => {
  return request({
    url: `/customer/customerScheme/save`,
    method: 'post',
    data,
  })
}

//删除
export const customerSchemeDelete = (data: any) => {
  return request({
    url: `/customer/customerScheme/delete`,
    method: 'post',
    data,
  })
}

/**
 * 工时上传
 */

// 列表
export const batchList = (data: any) => {
  return request({
    url: `/kefu/financeHours/batchList`,
    method: 'post',
    data,
  })
}
// 下载模板
export const templateDownload = () => {
  return request({
    url: `/kefu/financeHours/templateDownload`,
    method: 'get',
  })
}
// 详情
export const detailList = (data: any) => {
  return request({
    url: `/kefu/financeHours/batch/detailList`,
    method: 'post',
    data,
  })
}

// 详情-操作
export const uploadBatchConfirm = (data: any) => {
  return request({
    url: `/kefu/financeHours/uploadBatchConfirm`,
    method: 'post',
    data,
  })
}

// 批量数据确认
export const batchConfirm = (data: any) => {
  return request({
    url: `/kefu/financeHours/batch/detailList/batchConfirm`,
    method: 'post',
    data,
  })
}

// 工时结算明细
export const financeHoursDetailList = (data: any) => {
  return request({
    url: `/kefu/financeHours/detailList`,
    method: 'post',
    data,
  })
}
// 上传人员
export const userList = (data: any = {}) => {
  return request({
    url: `/kefu/financeHours/batch/userList`,
    method: 'post',
    data,
  })
}

/**
 * 工时统计
 */

// 客服服务工时列表
export const kefuServiceList = (data: any) => {
  return request({
    url: `/kefu/financeHours/kefuServiceList`,
    method: 'post',
    data,
  })
}
// 企业详情
export const kefuServiceCustomerDetailListNew = (data: any) => {
  return request({
    url: `/kefu/financeHours/kefuServiceCustomerDetailList`,
    method: 'post',
    data,
  })
}
// 企业统计
export const customerUploadStatusListNew = (data: any) => {
  return request({
    url: `/kefu/financeHours/customerUploadStatusList`,
    method: 'post',
    data,
  })
}
// 企业详情
export const summaryDetailList = (data: any) => {
  return request({
    url: `/kefu/financeHours/customerUploadStatusList/detailList`,
    method: 'post',
    data,
  })
}

// 客服人员明细列表
export const kefuServiceDetailList = (data: any) => {
  return request({
    url: `/kefu/financeHours/kefuServiceDetailList`,
    method: 'post',
    data,
  })
}

// 招聘
export const recruitmentServiceList = (data: any) => {
  return request({
    url: `/kefu/financeHours/recruitmentServiceList`,
    method: 'post',
    data,
  })
}

// 招聘人员明细列表
export const recruitmentServiceDetailList = (data: any) => {
  return request({
    url: `/kefu/financeHours/recruitmentServiceDetailList`,
    method: 'post',
    data,
  })
}

/**
 * 投诉判定
 */

// 待/已判定
export const kefuComplaintList = (data: any) => {
  return request({
    url: `/kefu/performance/kefuComplaint/list`,
    method: 'post',
    data,
  })
}

// 批量判定
export const batchJudge = (data: any) => {
  return request({
    url: `/kefu/performance/kefuComplaint/batchJudge`,
    method: 'post',
    data,
  })
}

/**
 * 参保统计
 */

// 统计
export const statisticsGroupList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/statisticsGroupList`,
    method: 'post',
    data,
  })
}

// 详情
export const statisticsList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/statisticsList`,
    method: 'post',
    data,
  })
}
/**
 * 申诉处理
 */

export const appealList = (data: any) => {
  return request({
    url: `/kefu/performance/kefuComplaint/appeal/list`,
    method: 'post',
    data,
  })
}

export const appealBatchJudge = (data: any) => {
  return request({
    url: `/kefu/performance/kefuComplaint/appeal/batchJudge`,
    method: 'post',
    data,
  })
}

/**
 * 客服管理-客服绩效
 */

export const performanceList = (data: any) => {
  return request({
    url: `/kefu/performance/list`,
    method: 'post',
    data,
  })
}

/**
 * 预支协议
 */

// 借支协议列表
export const borrowSignSettingList = (data: any) => {
  return request({
    url: `/finance/borrowSignSetting/getList`,
    method: 'post',
    data,
  })
}

export const updateState = (data: any) => {
  return request({
    url: `/finance/borrowSignSetting/updateState`,
    method: 'post',
    data,
  })
}
// 删除
export const borrowSignSettingDelete = (data: any) => {
  return request({
    url: `/finance/borrowSignSetting/delete`,
    method: 'post',
    data,
  })
}

// 保存借支协议
export const borrowSignSettingSave = (data: any) => {
  return request({
    url: `/finance/borrowSignSetting/save`,
    method: 'post',
    data,
  })
}

export const getDepartmentSelect = (data: any = {}) => {
  return request({
    url: `/finance/borrowSignSetting/getDepartmentSelect`,
    method: 'post',
    data,
  })
}

//
export const borrowSignSettingDetail = (data: any) => {
  return request({
    url: `/finance/borrowSignSetting/getDetail`,
    method: 'post',
    data,
  })
}

// 客服管理 -在职时长
export const onJobDaysList = (data: any) => {
  return request({
    url: `/kefu/onjob/days/list`,
    method: 'post',
    data,
  })
}
// 客服管理 -回访管理 -回访统计看板
export const getDashboard = (data: any) => {
  return request({
    url: `/kefu/followUp/dashboard`,
    method: 'post',
    data,
  })
}
// 客服管理 -回访管理 -回访统计看板-按人员视角
export const dashboardUser = (data: any) => {
  return request({
    url: `/kefu/followUp/dashboardUser`,
    method: 'post',
    data,
  })
}

// 客服管理 -回访管理 -回访统计看板-明细
export const getDashboardDetail = (data: any) => {
  return request({
    url: `/kefu/followUp/dashboard/detail`,
    method: 'post',
    data,
  })
}

// 客服管理 -回访管理 -回访统计看板-明细-按人员视角
export const dashboardUserDetail = (data: any) => {
  return request({
    url: `/kefu/followUp/dashboardUser/detail`,
    method: 'post',
    data,
  })
}

// 客服管理 -回访管理 -回访统计看板-明细合计挽留天数
export const getDetailTotal = (data: any) => {
  return request({
    url: `/kefu/followUp/dashboard/detailTotal`,
    method: 'post',
    data,
  })
}
// 客服管理 -回访管理 -回访成效分析-按人员列表
export const getAnalysisUserForData = (data: any) => {
  return request({
    url: `/kefu/followUp/effection/analysisUser`,
    method: 'post',
    data,
  })
}
// 客服管理 -回访管理 -回访成效分析-按区域列表
export const getAnalysisAreaForData = (data: any) => {
  return request({
    url: `/kefu/followUp/effection/analysisArea`,
    method: 'post',
    data,
  })
}
/**
 * 计提管理-计提数据统计
 */
// 集体金额统计列表
export const getProvisionAmountStatistic = (data: any) => {
  return request({
    url: `/provision/provisionRecordV2/provisionAmountStatistic`,
    method: 'post',
    data,
  })
}
// 计提管理-计提数据统计-企业视角
export const provisionAmountStatisticCustomerView = (data: any) => {
  return request({
    url: `/provision/provisionRecordV2/provisionAmountStatisticCustomerView`,
    method: 'post',
    data,
  })
}

/**
 * 财务-社保明细
 */

export const financeMemberList = (data: any) => {
  return request({
    url: `/finance/socialSecurity/ledger/finance/memberList`,
    method: 'post',
    data,
  })
}
